module.exports = __webpack_public_path__ + "static/media/finish_1.9f92e005.jpg";